import * as thirdPartyPersonName from './thirdPartyPersonName';
import * as thirdPartyPersonAddress from './thirdPartyPersonAddress';
import * as discloseInformation from './discloseInformation';
import * as informationToDiscloseOther from './informationToDiscloseOther';
import * as lengthOfRelease from './lengthOfRelease';
import * as securitySetup from './securitySetup';
import * as securitySetupPinPassword from './securitySetupPinPassword';
import * as securitySetupCustomQuestion from './securitySetupCustomQuestion';
import * as securitySetupMotherBornLocation from './securitySetupMotherBornLocation';
import * as securitySetupHighSchool from './securitySetupHighSchool';
import * as securitySetupPetName from './securitySetupPetName';
import * as securitySetupTeacherName from './securitySetupTeacherName';
import * as securitySetupFatherMiddleName from './securitySetupFatherMiddleName';

export {
  thirdPartyPersonName,
  thirdPartyPersonAddress,
  discloseInformation,
  informationToDiscloseOther,
  lengthOfRelease,
  securitySetup,
  securitySetupPinPassword,
  securitySetupCustomQuestion,
  securitySetupMotherBornLocation,
  securitySetupHighSchool,
  securitySetupPetName,
  securitySetupTeacherName,
  securitySetupFatherMiddleName,
};
